import React, { useContext } from 'react';
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import { AppContext } from '../../contexts/AppContext';
import bookPhoto from '../../images/plan-a-media-group-book-intro-session.gif';


export default function What() {
  const { useMobileView } = useContext(AppContext);

  return (
    <Box
      sx={{
        border: '2px solid white',
        borderRadius: '4px',
        padding: '24px',
        borderLeft: useMobileView ? 'none' : '2px solid white'
      }}
    >
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
            But really, it's all about you...
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography>
            <b>Plan <span style={{ color: 'red' }}>A</span></b> Media group is here to help your needs, your projects, 
            and your results with an individualized plan of attack to bring your
            endeavor into being, to put your best foot forward, to elevate your work.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography align="center" variant="h6" style={{ fontStyle: 'italic', fontWeight: 'bold' }}>
            <u>Your talent is ammunition, let's make sure you hit your target.</u>
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography>
            Regardless of how great you or your project are...there are moments when you are so 'in it' you can become lost. You
            know your project inside and out, and your brain automatically fills in the gaps. I'm a new viewpoint to help confirm
            if the vision in your mind is making it onto the screen, the page, the pitch...and where and how you can refine your
            vision, advance your output, fine-tune your project. I help bring precision, find solutions and make sure what you are
            trying to say is what is being said / seen / experienced.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography>
          You don't come to me for praise, though I will happily give it. You come to me for generative criticism, for constructive 
          guidance, brainstorming, accountability and problem solving.  We find solutions so only your best is going out to the wider world.
          </Typography>
        </Grid>
        <Grid item xs={12} justifyContent='center'>
          <Typography
            sx={{
              fontWeight: 'bold',
              marginLeft: '15%',
              marginRight: '15%'
            }}
          >
            Plan <span style={{ color: 'red' }}>A</span> Media Group: bringing clarity and new perspective to your film, script, pitch, project, communications, ideas,
            materials, goals...or the creative problems you are trying to solve.
          </Typography>
        </Grid>
        <Grid item xs={12} container justifyContent="center">
          {!useMobileView ? (
            <Avatar
              variant={"rounded"}
              src={bookPhoto}
              alt="Book a 2 hour consult with Adrienne"
              sx={{ width: '50%', height: '100%', cursor: 'pointer' }}
              onClick={() => window.open('https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=5N3BQH9D4UNWU', '_blank')}
            />
          ) : (
            <img
              src={bookPhoto}
              alt="Book a 2 hour consult with Adrienne"
              width='300px'
              height='300px'
              onClick={() => window.open('https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=5N3BQH9D4UNWU', '_blank')}
            />
          )}
        </Grid>      
      </Grid>
    </Box>
  );
}